import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { TestimonialAuthor } from '../testimonial-author';
import { TestimonialCompany } from '../testimonial-company';
import { innerDivider } from '../testimonial-card-shared';
import * as SX from './sx';
import type { TestimonialCardLinkedinProps as Props } from './types';

export const TestimonialCardLinkedin = memo(
  ({ testimonial, className }: Props) => {
    const { name, role, company, avatar, logo, quote, url } = testimonial;

    return (
      <Box
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={classnames('TestimonialCardLinkedin', className)}
        sx={SX.root}
      >
        <TestimonialAuthor
          name={name}
          role={role}
          company={company}
          avatar={avatar}
          badgeLabel="LinkedIn"
          badgeColor="primary"
        />

        <Typography variant="body4" color="grey.700" mb={2}>
          {quote}
        </Typography>

        <Divider sx={innerDivider} />
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          justifyContent="space-between"
          pt={1.5}
        >
          <TestimonialCompany company={company} logo={logo} />
          <Button
            variant="soft"
            color="default"
            size="xsmall"
            endIcon={<Icon name="arrow-outward-outline" size={14} />}
          >
            View on LinkedIn
          </Button>
        </Stack>
      </Box>
    );
  }
);

TestimonialCardLinkedin.displayName = 'TestimonialCardLinkedin';
